import { Expose } from 'class-transformer';
import { IsBoolean, IsDefined, IsEmail, IsEnum, IsNotEmpty, IsOptional, IsString } from '@lgce/class-validator';
import { IsOptionalIf } from '../decorators';
import { RoleType } from '../types';

export class CreateUserDto {
    @Expose()
    public id?: string;

    @IsBoolean()
    @IsOptional()
    @Expose()
    public active!: boolean;

    @IsString()
    @IsNotEmpty()
    @IsDefined()
    @Expose()
    public firstname!: string;

    @IsString()
    @IsNotEmpty()
    @IsDefined()
    @Expose()
    public lastname!: string;

    @IsEmail()
    @IsString()
    @IsOptionalIf((user: CreateUserDto) => user.role === RoleType.SUBSCRIBER)
    @Expose()
    public email?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public password?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public entity?: string;

    @IsString()
    @IsOptional()
    @Expose()
    public job?: string;

    @IsEnum(RoleType)
    @IsDefined()
    @Expose()
    public role!: RoleType;

    @IsString()
    @IsNotEmpty()
    @IsOptionalIf((user: CreateUserDto) => user.role === RoleType.ADMIN)
    @Expose()
    public agencyId!: string;

    @IsBoolean()
    @IsOptional()
    @Expose()
    public tosAccepted?: boolean;
}
